import getColour from '@lendi-ui/commons/colours';
import ErrorIcon from '@lendi-ui/icon/Error';
import { Body } from '@lendi-ui/typography';

import { BUTTON_STATUS } from '@funnels/constants';
import { FunnelGrid, FunnelGridUnit } from '@funnels/ui-components';

import { StatusTextWrapper } from '../index.style';

interface SaveStatusProps {
  buttonStatus: BUTTON_STATUS;
  buttonStatusText: string;
  handleCancel?: () => void;
}

export function SaveStatus({ buttonStatus, buttonStatusText, handleCancel }: SaveStatusProps) {
  //  for single button UI
  if (!handleCancel) {
    return (
      <FunnelGrid>
        <FunnelGridUnit>
          <StatusTextWrapper buttonStatus={buttonStatus}>
            {buttonStatus === BUTTON_STATUS.SAVING_UNSUCCESSFUL && (
              <Body size="xs" color="error.500" data-testid="save-all-error">
                <ErrorIcon color={getColour('interaction', 'error')} height="100%" /> {buttonStatusText}
              </Body>
            )}
            {buttonStatus !== BUTTON_STATUS.SAVING_UNSUCCESSFUL && (
              <Body size="xs" data-testid="save-comment-success">
                {buttonStatusText}
              </Body>
            )}
          </StatusTextWrapper>
        </FunnelGridUnit>
      </FunnelGrid>
    );
  }

  return (
    <FunnelGrid>
      <FunnelGridUnit size={1 / 2} />
      <FunnelGridUnit size={1 / 2} ml={'auto'}>
        <StatusTextWrapper buttonStatus={buttonStatus}>
          {buttonStatus === BUTTON_STATUS.SAVING_UNSUCCESSFUL && (
            <Body size="xs" color="error.500" data-testid="save-all-error">
              <ErrorIcon color="error.500" height="100%" /> {buttonStatusText}
            </Body>
          )}
          {buttonStatus !== BUTTON_STATUS.SAVING_UNSUCCESSFUL && (
            <Body size="xs" data-testid="save-comment-success">
              {buttonStatusText}
            </Body>
          )}
        </StatusTextWrapper>
      </FunnelGridUnit>
    </FunnelGrid>
  );
}
